import snakecaseKeys from 'snakecase-keys';

import api from './api';
import { Error } from '/types/apiResponseTypes';
import {
    PartialTemplateJobLineItem,
    TemplateJobLineItem,
} from '/types/lineItemTypes';
import { JobTemplate } from '/types/jobTemplateTypes';

type Response<D> = Promise<
    | {
          data: D;
      }
    | Error
>;

const calculationsApi = {
    getForLineItem: ({
        lineItem,
        projectId,
        offerId,
    }: {
        lineItem: PartialTemplateJobLineItem;
        projectId?: number;
        offerId?: number;
    }): Response<TemplateJobLineItem['data']> => {
        let q = '';
        if (projectId) q = `?project_id=${projectId}`;
        if (offerId) q = `?offer_id=${offerId}`;

        const data = {
            ...snakecaseKeys(lineItem, { deep: false }),
            data: snakecaseKeys(lineItem?.data || {}, { deep: false }),
        };

        return api.post(`calculation/line-item${q}`, data);
    },

    getForRawJobTemplateData: (
        jobTemplate: PartialTemplateJobLineItem
    ): Response<JobTemplate> =>
        api.post(
            `calculation/raw-job`,
            snakecaseKeys(jobTemplate, { deep: false })
        ),
};

export default calculationsApi;
